import React, { memo } from 'react';
import { Interpolate, Gold } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';
import { ROLE_NAMES } from '~/roles';

import styles from './ClanNameEditDialog.scss';

import type { ICurrentAccountState } from '~/Reducers/ReducerCurrentAccount';

interface ClanNameEditMessagesProps {
  currentAccount: ICurrentAccountState;
  cost: number;
  onShowRules: () => void;
}

const ClanNameEditMessages: React.FC<ClanNameEditMessagesProps> = ({ currentAccount, cost, onShowRules }) => {
  const rulesLink = (
    <span className={styles.link} onClick={onShowRules}>
      {t('Правила кланов')}
    </span>
  );

  return (
    <div className={styles.messages}>
      {currentAccount.isFreeRenameAvailable ? (
        <>
          <Interpolate
            className={styles.rules}
            str={t('Администрация игры изменила тег и название вашего клана, так как они нарушали %(rules)s')}
            rules={rulesLink}
          />
          <Interpolate
            str={
              currentAccount.roleName === ROLE_NAMES.COMMANDER
                ? t(
                    'Как командующий флотом, вы можете 1 раз бесплатно изменить тег и название клана. В следующий раз стоимость переименования составит %(dublons)s',
                  )
                : t(
                    'Командующий флотом может 1 раз бесплатно изменить тег и название клана. Как заместитель командующего, вы можете изменить тег и название за %(dublons)s',
                  )
            }
            dublons={<Gold amount={cost} />}
            noWrap
          />
        </>
      ) : (
        <div className={styles.rules}>
          <Interpolate str={t('При изменении тега и названия соблюдайте %(clanRules)s')} clanRules={rulesLink} />
        </div>
      )}
      <div className={styles.info}>{t('Переименование может занять некоторое время')}</div>
    </div>
  );
};

export default memo(ClanNameEditMessages);
